import { render, staticRenderFns } from "./userhistory.vue?vue&type=template&id=dc4649b8&scoped=true&"
import script from "./userhistory.vue?vue&type=script&lang=js&"
export * from "./userhistory.vue?vue&type=script&lang=js&"
import style0 from "./userhistory.vue?vue&type=style&index=0&id=dc4649b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4649b8",
  null
  
)

export default component.exports